module.exports = __webpack_public_path__ + "src/assets/textures/leaves/cotton_leaf_color_map.jpg";